<template>
    <div>
        <table-filter v-model="filter" :columns="columns"/>
        <div class="row justify-between">
            <div>
                <div v-if="selectedRows.length">Групповые действия:
                    <q-btn @click="openInvoiceDialog(selectedRows)">Отправка счетов</q-btn>
                </div>
            </div>
            <q-table-columns
                color="secondary"
                class="q-mr-sm"
                style="width: 100px;"
                v-model="visibleColumns"
                :columns="columns"
            />
        </div>
        <h-table
            :data="data"
            row-key="id"
            :columns="columns"
            :visible-columns="visibleColumns"
            :filter="filter"
            :pagination.sync="serverPagination"
            :rows-per-page-options="perPageOptions"
            selection="multiple"
            :selected.sync="selectedRows"
            :loading="loading"
            ref="table"
            @request="fetchBills"
        >
            <q-td
                slot="body-cell-project"
                slot-scope="props"
            >
                <a
                    :href="`/projects/${props.value.id}`"
                    target="_blank"
                >
                    {{ props.value.name }}
                </a>
            </q-td>
            <q-td
                slot="body-cell-destination"
                slot-scope="props"
            >
                {{ getBillPeriod(props.row.destination, props.row.service) }}
            </q-td>
            <q-td
                slot="body-cell-amount"
                slot-scope="props"
            >
                {{ formatMoney(props.value, props.row.project.region) }}
            </q-td>
            <q-td
                slot="body-cell-paid_amount"
                slot-scope="props"
            >
                {{ formatMoney(props.value, props.row.project.region) }}
                <q-btn
                    v-if="props.row.amount > props.row.paid_amount"
                    @click="editPaidAmount(props.row)"
                    icon="add"
                    flat
                    round
                    size="xs"
                    color="positive"
                />
            </q-td>
            <q-td
                slot="body-cell-edit"
                slot-scope="props"
                class="text-right"
            >
                <q-btn
                    @click="openInvoiceDialog(props.row)"
                    icon="send"
                    color="tertiary"
                    class="hover-primary"
                    flat
                    round
                >
                    <q-tooltip
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Отправить
                    </q-tooltip>
                </q-btn>
                <q-btn
                    @click="openInvoicePage(props.row)"
                    icon="insert_drive_file"
                    color="tertiary"
                    class="hover-positive"
                    flat
                    round
                >
                    <q-tooltip
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Просмотр
                    </q-tooltip>
                </q-btn>
                <q-btn
                    @click="generateActs(props.row)"
                    :disable="!billIsPaid(props.row) || !props.row.service"
                    icon="description"
                    color="tertiary"
                    class="hover-positive"
                    flat
                    round
                >
                    <q-tooltip
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Сгенерировать акты
                    </q-tooltip>
                </q-btn>
                <q-btn
                    @click="showRefundModal(props.row)"
                    :disable="!billIsPaid(props.row) || props.row.status === 'REFUNDED'"
                    icon="next_week"
                    color="tertiary"
                    class="hover-positive"
                    flat
                    round
                >
                    <q-tooltip
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Возврат денежных средств
                    </q-tooltip>
                </q-btn>
                <q-btn
                    @click="editBill(props.row)"
                    :disable=!canEdit(props.row)
                    icon="edit"
                    color="tertiary"
                    class="hover-primary"
                    flat
                    round
                >
                    <q-tooltip
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Редактировать
                    </q-tooltip>
                </q-btn>
                <q-btn
                    @click="deleteBill(props.row)"
                    :disable=!canDelete(props.row)
                    icon="delete"
                    color="tertiary"
                    class="hover-negative"
                    flat
                    round
                >
                    <q-tooltip
                        :delay="500"
                        :offset="[0, 5]"
                    >
                        Удалить
                    </q-tooltip>
                </q-btn>
            </q-td>
        </h-table>
        <q-modal
            v-model="updateBillOpened"
            content-css="width: 400px;"
        >
            <div class="q-pa-lg bill">
                <q-field>
                    <q-input
                        v-model="bill.number"
                        stack-label="Счет"
                        disabled
                    />
                </q-field>
                <q-field>
                    <q-input
                        v-model="bill.comment"
                        stack-label="Комментарий"
                    />
                </q-field>
                <q-field>
                    <q-datetime
                        v-model="bill.paid_at"
                        type="datetime"
                        clearable
                        :disable="bill.status === 'NEW'"
                        stack-label="Дата оплаты"
                    />
                </q-field>
            </div>
            <div class="row justify-end q-pa-lg">
                <q-btn
                    :loading="saving"
                    @click="updateBill"
                    color="primary"
                    class="q-mr-xs"
                    label="Сохранить"
                />
                <q-btn
                    @click="updateBillOpened = false"
                    color="primary"
                    flat
                    label="Отмена"
                />
            </div>
        </q-modal>
        <q-modal
            v-model="incomeTransactionOpened"
            @show="$refs.incomeTransactionInput.focus()"
            content-css="width: 400px;"
        >
            <div class="q-pa-lg bill">
                Регистрация прихода по счёту {{ transaction.number }}
                <q-field
                    :error="$v.transaction.amount.$error"
                    error-label="Сумма оплаты превышает сумму выставленного счета"
                >
                    <q-input
                        ref="incomeTransactionInput"
                        v-model="transaction.amount"
                        @keyup.delete="transaction.amoun = null"
                        @keyup.enter="incomeTransaction()"
                        stack-label="Сумма"
                        type="number"
                    />
                    <q-datetime
                        v-model="transaction.paid_at"
                        type="datetime"
                        clearable
                        stack-label="Дата оплаты"
                    />
                    <q-field
                        :error="$v.transaction.paymentMethod.$error"
                        error-label="Укажите метод оплаты"
                    >
                        <q-select
                            v-model="transaction.paymentMethod"
                            :options="paymentMethodOptions"
                            stack-label="Способ оплаты"
                        />
                    </q-field>
                </q-field>

            </div>
            <div class="row justify-end q-pa-lg">
                <q-btn
                    @click="incomeTransactionOpened = false; resetTransactionData()"
                    label="Отмена"
                    style="margin-right: 10px;"
                />
                <q-btn
                    @click="incomeTransaction()"
                    label="Сохранить"
                    color="primary"
                />
            </div>
        </q-modal>

        <act-modal
            v-if="actModalOpened"
            v-bind:bill="bill"
            v-bind:opened.sync="actModalOpened"
        />

        <refund-modal
            v-if="refundModalOpened"
            :bill="bill"
            :opened="refundModalOpened"
            @closed="hideRefundModal"
        />

        <q-dialog
            v-model="invoiceDialog.opened"
            :title="invoiceDialog.title"
            :cancel="true"
            @ok="sendInvoices"
        >
            <div slot="body">
                <ul v-if="Array.isArray(invoiceDialog.bills)" class="bills-numbers">
                    <li v-for="bill in invoiceDialog.bills">
                        {{ bill.number }}
                    </li>
                </ul>
                <p v-else> {{ invoiceDialog.bills.number }}</p>

                <q-option-group
                    type="radio"
                    v-model="invoiceDialog.receiver"
                    :options="invoiceDialog.options"
                />

                <div class="delivery-channels">
                    <q-checkbox v-model="invoiceDialog.channels" val="mail" label="По почте"/>
                    <q-checkbox v-model="invoiceDialog.channels" val="intercom" label="Интерком"/>
                </div>
            </div>
        </q-dialog>

    </div>
</template>

<script>
import { mapState } from 'vuex'

import { maxValue, required } from 'vuelidate/lib/validators'

import HTable from '@/HTable'
import HTh from '@/HTh'
import TableFilter from '@/TableFilter'

import columns from './mixins/columns'
import api from 'mixins/api'
import tableHelpers from '@/HTable/helpers'

import {
    date,
    QBtn,
    QBtnToggle,
    QCheckbox,
    QDatetime,
    QDialog,
    QField,
    QIcon,
    QInput,
    QModal,
    QOptionGroup,
    QPopover,
    QSelect,
    QTable,
    QTableColumns,
    QTd,
    QTh,
    QTooltip,
    QTr,
} from 'quasar'
import ActModal from './ActModal'
import fetchServiceProviders from '../../mixins/fetchServiceProviders'
import billService from '../../mixins/billService'
import currency from '../../mixins/currency'
import RefundModal from './RefundModal.vue'

export default {
    name: 'Bills',

    components: {
        RefundModal,
        ActModal,
        HTable,
        HTh,
        TableFilter,
        QField,
        QInput,
        QSelect,
        QBtn,
        QIcon,
        QTable,
        QTableColumns,
        QTr,
        QTh,
        QTd,
        QPopover,
        QTooltip,
        QModal,
        QDatetime,
        QBtnToggle,
        QCheckbox,
        QDialog,
        QOptionGroup,
        date,
    },

    mixins: [
        tableHelpers,
        columns,
        api,
        fetchServiceProviders,
        billService,
        currency,
    ],

    computed: mapState({
        project: state => state.project.data,
    }),

    watch: {
        'transaction.amount' (value) {
            if (value <= this.transaction.maxValue) {
                this.$v.transaction.$reset()
            }
        },
    },

    data () {
        return {
            userId: null,
            projectId: null,
            visibleColumns: this.getVisibleColumns() || [
                'number',
                'project',
                'amount',
                'paid_amount',
                'payment_method',
                'comment',
                'edit',
            ],
            newBillOpened: false,
            updateBillOpened: false,
            incomeTransactionOpened: false,
            actModalOpened: false,
            refundModalOpened: false,
            servicesData: null,
            servicesOptions: [],
            saving: false,
            statuses: [
                {
                    label: 'Новый',
                    value: 'NEW',
                },
                {
                    label: 'Просрочен',
                    value: 'EXPIRED',
                },
                {
                    label: 'Оплачен',
                    value: 'PAID',
                },
                {
                    label: 'Частично оплачен',
                    value: 'PARTIALLY_PAID',
                },
                {
                    label: 'Отклонен',
                    value: 'REFUSED',
                },
                {
                    label: 'Возврат',
                    value: 'REFUNDED',
                },
            ],
            bill: {
                id: null,
                number: null,
                serviceId: null,
                status: 'NEW',
                amount: null,
                paidAmount: null,
                comment: null,
                paid_at: null,
                payment_method: null,
                paymentMethodCache: null,
            },
            transaction: {
                billId: null,
                number: null,
                amount: null,
                minValue: 0,
                maxValue: 0,
                paid_at: '',
                paymentMethod: null,
            },
            act: {
                customer: '',
                requisites: '',
                initials: '',
                date: '',
            },
            invoiceDialog: {
                opened: false,
                title: '',
                options: [],
                receiver: null,
                bills: '',
                channels: ['mail', 'intercom'],
            },
            paymentMethodOptions: [
                {
                    label: 'WayForPay',
                    value: 'wayforpay',
                },
                {
                    label: 'Баланс',
                    value: 'balance',
                },
                {
                    label: 'Приват24',
                    value: 'privat',
                },
                {
                    label: 'LiqPay',
                    value: 'liqpay',
                },
              {
                label: 'Stripe',
                value: 'stripe',
              },
            ],
        }
    },

    validations () {
        return {
            transaction: {
                amount: {
                    required,
                    maxValue: maxValue(this.transaction.maxValue),
                },
                paymentMethod: {
                    required,
                },
            },
        }
    },

    mounted () {
        this.updateBills()
        this.fetchManagers()
        this.fetchServiceProviders()
    },

    methods: {
        updateBills () {
            this.fetchBills({
                pagination: this.serverPagination,
                filter: this.filter,
            })
        },

        setPaymentMethodCache () {
            this.bill.paymentMethodCache = this.bill.payment_method
        },

        fetchBills ({ pagination, filter }) {
            this.loading = true
            this.query = this.getQuery(pagination, filter)
            this.api.get(`bills/${this.query}`).then((response) => {
                this.updatePagination(pagination, response.data.total)
                this.updateData(response.data.bills)
                this.$store.commit('billsList/setData', response.data)
                this.loading = false
            }).catch(error => {
                console.error(error)
                this.loading = false
            })
        },

        fetchManagers () {
            this.$http.get(`api/v1.0/users?filter[role][]=root&filter[role][]=manager&perPage=60`).then(response => {
                this.columns.find(obj => obj.name === 'project_manager').values = response.data.users.map(val => {
                    return {
                        label: val.first_name + ' ' + val.last_name,
                        value: val.id,
                    }
                })
            })
        },

        getInvoiceUrl (data) {
            return this.$router.resolve({ path: `/invoice/${data.id}`, query: { userId: data.user_id } }).href
        },

        openInvoicePage (data) {
            window.open(this.getInvoiceUrl(data), '_blank')
        },

        openInvoiceDialog (bills) {
            const isManyReceivers = Array.isArray(bills)
            this.invoiceDialog.bills = bills

            if (isManyReceivers) {
                this.invoiceDialog.title = `Отправка счетов`
                this.invoiceDialog.options = [
                    { label: `Клиенту и менеджерам проекта`, value: null },
                    { label: `Менеджеру (${this.$auth.user().email})`, value: this.$auth.user().id },
                ]

            } else {
                this.invoiceDialog.title = `Отправка счета`
                this.invoiceDialog.options = [
                    { label: `Клиенту и менеджерам проекта`, value: null },
                    { label: `Менеджеру (${this.$auth.user().email})`, value: this.$auth.user().id },
                ]
            }
            this.invoiceDialog.receiver = this.invoiceDialog.options[0].value

            this.invoiceDialog.opened = true
        },

        sendInvoices () {
            const bills = this.invoiceDialog.bills

            const fulfilled = (response) => {
                this.$q.notify({ message: response.data.message, type: 'positive' })
            }
            const rejected = (error) => {
                this.$q.notify({ message: error.response.data.message, type: 'negative' })
            }

            if (Array.isArray(bills)) {
                this.$http.post(`/api/v1.0/bills/notify-batch`, {
                    bills: bills.map(bill => bill.id),
                    receiver_id: this.invoiceDialog.receiver,
                    delivery_channels: this.invoiceDialog.channels,
                }).then(fulfilled).catch(rejected)
            } else {
                this.$http.post(`/api/v1.0/users/${bills.user_id}/bills/${bills.id}/notify`, {
                    receiver_id: this.invoiceDialog.receiver,
                    delivery_channels: this.invoiceDialog.channels,
                }).then(fulfilled).catch(rejected)
            }

            this.invoiceDialog.opened = false
        },

        editBill (data) {
            this.updateBillOpened = true
            Object.assign(this.bill, data)
            this.setPaymentMethodCache()
        },

        canEdit (bill) {
            return this.$auth.user().role === 'root' || this.$auth.user().role === 'accountant' || bill.paid_amount ===
                0
        },

        canDelete (bill) {
            return this.$auth.user().role === 'root' || bill.paid_amount === 0 || this.$auth.user().role ===
                'accountant'
        },

        deleteBill (data) {
            const message = data.paid_amount !== 0 ?
                `Счёт имеет внесенный платеж на сумму ${data.paid_amount /
                100} грн Вы точно хотите удалить счёт?` :
                'Удалить счёт?'

            this.$q.dialog({
                title: 'Осторожно!',
                message: message,
                ok: true,
                cancel: true,
            }).then(receiver_id => {
                this.$http.delete(`/api/v1.0/users/${data.user_id}/bills/${data.id}`).then(response => {
                    this.$q.notify({ message: 'Счёт был успешно удалён', type: 'positive' })
                    this.fetchBills({
                        pagination: this.serverPagination,
                        filter: this.filter,
                    })
                    this.$store.dispatch('project/fetchBalance', this.project.id)
                }).catch(errors => {
                    this.$q.notify({
                        message: 'Ошибка при удалении счёта. Вы не можете удалять уже оплаченные счета',
                        type: 'negative',
                    })
                })
            }).catch(() => {
            })
        },

        updateBill () {
            this.saving = true
            let data = {
                'comment': this.bill.comment,
                'paid_at': this.bill.paid_at,
            }
            if (this.bill.payment_method !== this.bill.paymentMethodCache) {
                data['payment_method'] = this.bill.payment_method
            }
            this.$http.put(`/api/v1.0/users/${this.bill.user_id}/bills/${this.bill.id}`, data).then(() => {
                this.$store.commit('billsList/updateBill', this.bill)
                this.updateBillOpened = false
                this.$q.notify({ message: 'Сохранено', type: 'positive' })
            }).catch(error => {
                this.$q.notify({ message: 'Возникала ошибка при сохранении.', type: 'negative' })
                _.forIn(error.response.data, (value, key) => {
                    this.$q.notify({ message: value, type: 'negative' })
                })
            }).then(() => {
                this.saving = false
            })
        },

        editPaidAmount (data) {
            this.transaction.billId = data.id
            this.transaction.number = data.number

            this.incomeTransactionOpened = true
            this.transaction.maxValue = this.formatNumber(data.amount - data.paid_amount, 1 / 100)
        },

        incomeTransaction () {
            this.$v.transaction.$touch()

            if (this.$v.transaction.$error) {
                return
            }

            let bill = this.data.find(row => row.id === this.transaction.billId),
                transaction = {
                    bill_id: this.transaction.billId,
                    payment_method: this.transaction.paymentMethod,
                    amount: this.formatNumber(this.transaction.amount, 100),
                    created_at: this.transaction.paid_at,
                    project_id: bill.project_id,
                }

            this.incomeTransactionOpened = false
            this.$http.post(`/api/v1.0/users/${bill.user_id}/transactions/income`, transaction).then(response => {
                Object.assign(bill, {
                    paid_amount: bill.paid_amount + transaction.amount,
                })

                this.$store.commit('billsList/updateBill', bill)
                this.$q.notify({ message: 'Сохранено', type: 'positive' })
                this.$store.dispatch('project/fetchBalance', this.project.id)

                this.resetTransactionData()
            }).catch(error => {
                const message = error.message
                this.$q.notify({ message: 'Ошибка', type: 'negative' })
                this.$q.notify({ message: message, type: 'negative' })
            })
        },

        resetTransactionData () {
            this.transaction.amount = null
            this.transaction.paymentMethod = null
            this.$v.transaction.$reset()
        },

        showActModal (bill) {
            this.actModalOpened = true
            this.bill = bill
        },

        showRefundModal (bill) {
            this.refundModalOpened = true
            this.bill = bill
        },

        hideRefundModal () {
            this.refundModalOpened = false
        },

        generateActs (bill) {
            this.$http.get(`/api/v1.0/projects/${bill.project.id}/acts/${bill.id}/generateActs`).then(response => {
                if (response.status === 201) {
                    this.$q.notify({
                        message: 'Акты по данному счёту были сгенерированы ранее и доступны в разделе Акты.',
                        type: 'positive',
                    })
                    return
                }

                this.$q.notify({ message: 'Акты сгенерированы.', type: 'positive' })
            }).catch(error => {
                console.error(error)

                if (error.response.status === 400) {
                    this.$q.notify(
                        { message: 'Возникала ошибка при генерации актов. Проверьте реквизиты.', type: 'negative' })
                    return
                }

                this.$q.notify({ message: 'Возникала ошибка при генерации актов.', type: 'negative' })
            })
        },

        billIsPaid (bill) {
            return bill.amount === bill.paid_amount
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/BillsList/BillsList.vue